import LoginForm from "../component/LoginForm";
const Login = () => { return (<LoginForm />) }
export default Login;